import { brandSemantic } from './brand';

// Recomputed each time the active color palette changes (see brand.js
// `applyPalette`) — call this again after switching palettes rather than
// caching the result.
export const buildSidebarStyles = () => `
  .rich-text-editor-content img {
    max-width: 100%;
    height: auto;
  }

  .rich-text-editor-content p {
    margin: 0 0 8px;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }

  .custom-sidebar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 8px;
    margin: 3px 12px;
  }

  .custom-sidebar-item:hover {
    background: ${brandSemantic.sidebarItemHoverBg};
  }

  .custom-sidebar-item.active {
    background: ${brandSemantic.sidebarItemActiveBg};
  }

  .custom-sidebar-item .anticon {
    font-size: 20px;
    margin-bottom: 4px;
    color: ${brandSemantic.sidebarIconColor};
  }

  .custom-sidebar-item.active .anticon {
    color: ${brandSemantic.sidebarIconActiveColor};
  }

  .custom-sidebar-item .item-label {
    font-size: 11px;
    text-align: center;
    color: ${brandSemantic.sidebarLabelColor};
    font-weight: 500;
    line-height: 1.2;
  }

  .custom-sidebar-item.active .item-label {
    color: ${brandSemantic.sidebarLabelActiveColor};
    font-weight: 600;
  }

  .ant-menu-inline .ant-menu-item {
    height: 48px;
    line-height: 48px;
    margin: 4px 8px;
    border-radius: 8px;
  }

  .ant-menu-inline .ant-menu-item .anticon {
    font-size: 20px;
  }

  .status-tag-select .ant-select-selector {
    background: var(--status-bg) !important;
    border: 1px solid var(--status-border) !important;
    border-radius: 4px !important;
    min-height: 24px !important;
    height: 24px !important;
    padding: 0 24px 0 8px !important;
  }

  .status-tag-select .ant-select-selection-item {
    color: var(--status-color) !important;
    font-size: 12px;
    font-weight: 500;
    line-height: 22px !important;
  }

  .status-tag-select .ant-select-arrow {
    color: var(--status-color);
    font-size: 10px;
    right: 8px;
  }

  .soft-status-tag {
    display: inline-flex;
    align-items: center;
    min-height: 24px;
    padding: 0 8px;
    border-radius: 4px;
    border: 1px solid var(--tag-border);
    background: var(--tag-bg);
    color: var(--tag-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 22px;
    white-space: nowrap;
  }

  .inactive-table-row > td {
    opacity: 0.58;
  }

  .inactive-table-row:hover > td {
    opacity: 0.72;
  }

  .language-select .ant-select-selector {
    padding: 0 32px 0 10px !important;
  }

  .language-select .ant-select-selection-item {
    display: flex !important;
    align-items: center;
    line-height: normal !important;
    padding-inline-end: 0 !important;
  }

  .language-select .ant-select-arrow {
    color: ${brandSemantic.textTertiary};
  }

  .language-option-label {
    min-height: 20px;
  }

  .language-option-text {
    display: inline-flex;
    align-items: center;
    line-height: 20px;
  }

  .language-select-dropdown .ant-select-item-option-content {
    display: flex;
    align-items: center;
  }

  .page-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .page-toolbar-title {
    flex: 0 0 auto;
    min-width: max-content;
    white-space: nowrap;
  }

  .page-toolbar-controls {
    display: flex;
    gap: 8px;
    flex: 1 1 auto;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    min-width: 0;
  }

  .page-toolbar-controls .ant-input-affix-wrapper,
  .page-toolbar-controls .ant-input,
  .page-toolbar-controls .ant-select,
  .page-toolbar-controls .ant-select-selector,
  .page-toolbar-controls .ant-picker {
    height: 36px !important;
    box-sizing: border-box !important;
    border-radius: 10px !important;
  }

  .page-toolbar-controls .ant-input-affix-wrapper,
  .page-toolbar-controls .ant-input-search,
  .page-toolbar-controls .ant-input-group-wrapper,
  .page-toolbar-controls > .ant-select,
  .page-toolbar-controls .ant-space-item > .ant-select {
    width: 180px !important;
  }

  .page-toolbar-controls .ant-input-affix-wrapper,
  .page-toolbar-controls .ant-input,
  .page-toolbar-controls .ant-select-selector,
  .page-toolbar-controls .ant-picker {
    display: flex;
    align-items: center;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .page-toolbar-controls .ant-input-affix-wrapper > input.ant-input {
    height: 100% !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  @media (max-width: 1500px) {
    .page-toolbar-title {
      width: 100%;
    }

    .page-toolbar-controls {
      width: 100%;
      justify-content: flex-end;
    }
  }
`;
